import { MessageService } from 'primeng/primeng';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { CardDefinition } from '../../models/loyalty-card-definition.model';
import { URLSearchParams } from '@angular/http';
import { ListMetadata } from '../../models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltyCardDefinitionService {

  private cache = new Map<string, CardDefinition>();
  private cachedFields: Observable<any>;

  public baseUrl = '/koncentro-loyalty';

  constructor(private http: HttpClientService,
    private srvNotify: MessageService) {
  }

  get(cardDefinitionId): Observable<CardDefinition> {

    if (this.cache.has(cardDefinitionId)) {
      return Observable.of(this.cache.get(cardDefinitionId));
    }

    return this.http.get(this.baseUrl + '/card_def/' + cardDefinitionId).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  list (
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
  ): Observable<{ data: Array<CardDefinition>, metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/card_def/getCardDefList?' + params.toString());
   // return this.http.get(this.baseUrl + '/card_def/getCardDefList?' + params.toString());
  }

  getList(offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable<{ data: Array<CardDefinition>, metadata: ListMetadata }> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    if (offset !== null) {
      params.set('offset', offset.toString());
    }
    if (limit !== null) {
      params.set('limit', limit.toString());
    }

    return this.http.get(this.baseUrl + '/card_def/getCardDefList?' + params.toString());
  }

  update(cardDefinition: CardDefinition): Observable<CardDefinition> {
    return this.http.put(this.baseUrl + '/card_def/' + cardDefinition.id, cardDefinition).map(res => {
      this.cache.delete(cardDefinition.id);
      return res;
    });
  }

  create(cardDefinition: CardDefinition): Observable<CardDefinition> {
    return this.http.post(this.baseUrl + '/card_def/', cardDefinition);
  }

  remove(cardDefinitionId): Observable<CardDefinition> {
    return this.http.delete(this.baseUrl + '/card_def/' + cardDefinitionId).map(res => {
      this.cache.delete(cardDefinitionId);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      return res;
    });
  }
  recover(cardDef) {    
  return this.http.put(this.baseUrl + "/card_def/recover/" + cardDef.id, cardDef)
    .map(res => {
      this.cache.delete(cardDef.id);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/CardDefDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-card-definition.service.ts